<template>
  <div class="zhanwei3"></div>

  <div class="top-action-bar">
    <router-link to="">
      <el-button class="back-btn" @click="$router.back(-1)">
        {{ $t("List.button1") }}
      </el-button>
    </router-link>
    <router-link :to="'/'">
      <el-button class="home-btn" type="primary" plain>
        {{ $t("List.button2") }}
      </el-button>
    </router-link>
  </div>
  <div class="zhanwei3"></div>
  <div class="list-tabs-container">
    <el-tabs :tab-position="tabPosition" class="modern-tabs">
      <el-tab-pane :label="$t('List.creationList')">
        <div class="game-list-wrapper">
          <div
            class="game-card animate-card"
            v-for="(item, index) in gameList"
            :key="index"
          >
            <div class="game_left">
              <el-image :src="item.gameCover" fit="cover" class="cover-img">
                <template #placeholder>
                  <div class="image-slot-placeholder">加载中...</div>
                </template>
              </el-image>
            </div>

            <div class="game_center">
              <h3 class="game-title">{{ item.gameTitle || "未命名游戏" }}</h3>

              <div class="meta-tags">
                <el-tag
                  size="small"
                  type="info"
                  effect="plain"
                  class="meta-tag-id"
                >
                  ID: {{ item.id }}
                </el-tag>
                <el-tag
                  size="small"
                  type="success"
                  effect="light"
                  v-if="item.gameLanguage"
                >
                  {{ item.gameLanguage }}
                </el-tag>
                <span class="region-span">不限地区 — 任何地点</span>
              </div>

              <p class="create-time">建立于：{{ item.createTime }}</p>

              <p class="game-desc">
                {{ item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..." }}
              </p>
            </div>

            <div class="game_right">
              <div class="update-tip-box">
                <p v-if="item.updateTime" class="update-time">
                  {{ $t("List.tip") }}{{ item.updateTime }}
                </p>
              </div>
              <div class="btn-group">
                <el-button
                  type="primary"
                  size="default"
                  class="action-btn edit-btn"
                  @click="editGame(item.id)"
                >
                  {{ $t("List.button3") }}
                </el-button>
                <el-button
                  type="danger"
                  plain
                  size="default"
                  class="action-btn delete-btn"
                  @click="deleteGame(item.id)"
                >
                  {{ $t("List.button4") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="zhanwei3"></div>
        <div class="page-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="gamesTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('List.trashCan')">
        <div class="game-list-wrapper">
          <div
            class="game-card junk-card"
            v-for="(item, index) in junkGameList"
            :key="index"
          >
            <div class="game_left">
              <el-image :src="item.gameCover" fit="cover" class="cover-img" />
            </div>

            <div class="game_center">
              <h3 class="game-title">{{ item.gameTitle || "未命名游戏" }}</h3>

              <div class="meta-tags">
                <el-tag
                  size="small"
                  type="info"
                  effect="plain"
                  class="meta-tag-id"
                >
                  ID: {{ item.id }}
                </el-tag>
                <el-tag
                  size="small"
                  type="success"
                  effect="light"
                  v-if="item.gameLanguage"
                >
                  {{ item.gameLanguage }}
                </el-tag>
                <span class="region-span">不限地区 — 任何地点</span>
              </div>

              <p class="create-time">建立于：{{ item.createTime }}</p>
              <p class="game-desc">
                {{ item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..." }}
              </p>
            </div>

            <div class="game_right">
              <div class="update-tip-box">
                <p v-if="item.deleteTime" class="days-left">
                  剩余保留：<span class="highlight-days">{{
                    getDaysDifference(item.deleteTime)
                  }}</span>
                  天
                </p>
              </div>
              <div class="btn-group">
                <el-button
                  type="success"
                  size="default"
                  class="action-btn restore-btn"
                  @click="restore(item.id)"
                >
                  还原
                </el-button>
                <el-button
                  type="danger"
                  plain
                  size="default"
                  class="action-btn hard-delete-btn"
                  @click="completeDelete(item.id)"
                >
                  {{ $t("List.button4") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="zhanwei3"></div>
        <div class="page-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="junkGameListTotal"
            @current-change="handleCurrentChange2"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import { Game } from "@/views/view";
import { ElMessage, ElMessageBox } from "element-plus";
import { Delete } from "@element-plus/icons-vue";

export default defineComponent({
  name: "gameList",
  data(): any {
    return {
      currentPage: 1,
      currentPage2: 1,
      tabPosition: "left",
      junkGameListTotal: 1,
      junkGameList: [],
    };
  },
  computed: {
    gameList(): Array<Game> {
      return this.$store.state.game.games;
    },
    gamesTotal() {
      return this.$store.state.game.total;
    },
  },
  created() {
    this.fetchGameList(this.currentPage);
    this.fetchJunkGameList(this.currentPage2);
  },
  methods: {
    handleCurrentChange(val: number) {
      this.currentPage = val;
      this.fetchGameList(val);
    },
    handleCurrentChange2(val: number) {
      this.currentPage2 = val;
      this.fetchJunkGameList(val);
    },
    fetchGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getGameList", { pageNum, pageSize, userId, status })
        .catch((err: any) => {
          console.error(err);
        });
    },
    fetchJunkGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getJunkGameList", { pageNum, pageSize, userId, status })
        .then((res: any) => {
          this.junkGameListTotal = res.total;
          this.junkGameList = res.records;
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    getDaysDifference(endDate: any) {
      const start: any = new Date();
      const end: any = new Date(endDate);
      const timeDiff = end - start;
      const diffInDays = timeDiff / (1000 * 60 * 60 * 24);
      return Math.round(diffInDays);
    },
    editGame(id: string) {
      this.$router.push("/edit/" + id + "/cover");
    },
    restore(id: string) {
      this.$store
        .dispatch("game/restoreGame", { id: id })
        .then(() => {
          this.$message.success("还原成功");
          this.fetchGameList(this.currentPage);
          this.fetchJunkGameList(this.currentPage2);
        })
        .catch(() => {});
    },
    deleteGame(id: string) {
      ElMessageBox.confirm(this.$t("List.deleteInfo"), "警告", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
      })
        .then(() => {
          this.$store
            .dispatch("game/delGame", { ids: [id] })
            .then((res: any) => {
              if (res == 1) {
                this.$message.success("已移动至垃圾桶");
                this.fetchGameList(this.currentPage);
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    completeDelete(id: string) {
      ElMessageBox.confirm(
        "确定彻底删除该导览数据吗？此操作无法恢复！",
        "高危警告",
        {
          type: "warning",
          icon: markRaw(Delete),
          confirmButtonText: "彻底删除",
          cancelButtonText: this.$t("List.channel"),
          draggable: true,
        }
      )
        .then(() => {
          this.$store
            .dispatch("game/completeGame", { id: id })
            .then((res: any) => {
              if (res == 1) {
                this.$message.success("数据已彻底清除");
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
/* 顶栏控制 */
.top-action-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  .back-btn {
    border-color: #dcdfe6;
    color: #606266;
    font-weight: 500;

    &:hover {
      background: #f5f7fa;
      border-color: #c0c4cc;
    }
  }

  .home-btn {
    font-weight: 500;
  }
}

/* 选项卡大容器 */
.list-tabs-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;

  /* 穿透 Element Plus tabs 的基础侧边样式 */
  :deep(.modern-tabs) {
    .el-tabs__header {
      margin-right: 30px;
    }

    .el-tabs__item {
      font-size: 15px;
      font-weight: 600;
      height: 50px;
      line-height: 50px;
      color: #747d8c;
      transition: color 0.3s;

      &.is-active {
        color: #2c3e50;
      }
    }

    .el-tabs__active-bar {
      background-color: #2c3e50;
      width: 3px;
    }
  }
}

/* 列表卡片集合 */
.game-list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 卡片容器设计 */
.game-card {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.02);
  padding: 20px;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  align-items: center;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
  }

  /* 封面 */
  .game_left {
    width: 180px;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f1f2f6;

    .cover-img {
      width: 100%;
      height: 100%;
    }

    .image-slot-placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 12px;
      color: #a4b0be;
    }
  }

  /* 中间文字排版 */
  .game_center {
    flex: 1;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    .game-title {
      margin: 0 0 10px 0;
      font-size: 18px;
      font-weight: bold;
      color: #2f3542;
      line-height: 1.4;
    }

    .meta-tags {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 8px;
      flex-wrap: wrap;

      .meta-tag-id {
        font-weight: bold;
      }

      .region-span {
        font-size: 12px;
        color: #747d8c;
      }
    }

    .create-time {
      margin: 0 0 6px 0;
      font-size: 12px;
      color: #a4b0be;
    }

    .game-desc {
      margin: 0;
      font-size: 13px;
      color: #57606f;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  /* 右侧操作区 */
  .game_right {
    width: 180px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    height: 120px;
    flex-shrink: 0;
    box-sizing: border-box;

    .update-tip-box {
      font-size: 12px;
      text-align: right;

      .update-time {
        margin: 0;
        color: #747d8c;
      }

      .days-left {
        margin: 0;
        color: #e4393c;
        font-weight: 500;

        .highlight-days {
          font-size: 15px;
          font-weight: bold;
        }
      }
    }

    .btn-group {
      display: flex;
      gap: 8px;
      width: 100%;
      justify-content: flex-end;

      .action-btn {
        min-width: 70px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
    }
  }
}

/* 分页位置统一 */
.page-pagination {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
</style>
